module.exports = __webpack_public_path__ + "img/logo.bd0ccbbe.png";